<template>
    <div>
        <v-container 
            class="pt-0 pb-0"
            style="background-color: var(--v-editPageBackground-base);"
            fluid
        >

<!-- VALIDATION -->
            <ValidationObserver
                ref="editForm"
                v-slot="{ passes }"
            >
<!-- HEADLINE -->
                <v-row class="mb-2" style="background-color: var(--v-editPageHeadlineBackground-base);">
                    <v-col class="headline">
                        <slot name="headline" :data="data"></slot>
                    </v-col>
                    <v-col cols="auto" class="d-flex justify-end"> 
                        <!-- :to="getPrevRoute" -->
                        <BaseButton 
                            label="lang_GENERIC_CAPTION_BACK_TO_LIST"
                            :to="cancelIconRoute"
                            :disabled="isLoading"
                            color="iconCancelEditForm"
                            :alvqa="alvqa + '-icon-cancel'"
                        />   
                        <BaseButton v-if="showPrintBtn"
                            class="ml-4"
                            label="lang_GENERIC_CAPTION_PRINT"
                            @click.stop="printBtnFunction()"
                            :color="$route.params.alvId === 'new' ? 'iconCancelEditForm' : 'buttonStandard'"
                            :alvqa="alvqa + '-icon-print'"
                        /> 
                        <BaseButton 
                            class="ml-4"
                            label="lang_GENERAL_BUTTON_SAVE"
                            @click="passes(submit)"
                            :disabled="isLoading"
                            :alvqa="alvqa + '-icon-save'"
                            :abbreviation="abbreviation"
                        />                    
                    </v-col>
                </v-row>
<!-- MAIN EDIT FORM -->
                <v-row>
                    <slot name="editForm" :data="data"></slot>
                </v-row>
            </ValidationObserver>
<!-- PANELS -->
            <v-row>
                <v-col>
                    <v-expansion-panels 
                        :value="defaultOpenPanelsArray"
                        :multiple="openMultiplePanels"
                        focusable  
                        tile  
                        flat
                    >
                        <slot name="panels"></slot>
                    </v-expansion-panels> 
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import BaseIcon from '../_buttons/BaseIcon'
import BaseButton from '@/components/_buttons/BaseButton'

export default {
    name: "BaseEditPage",
    components: {
        BaseIcon,
        BaseButton,
    },
    props: {
        context: String,
        alvqa: String,
        cancelIconRoute: {
            default: '/dashboard',
            type: String
        },
        openMultiplePanels: {
            default: true,
            type: Boolean
        },
        defaultOpenPanelsArray: {
            type: Array,
            default() {
                return [] // do not open any panel by default, was [0] for first panel
            }
        },
        showPrintBtn: {
            default: false,
            type: Boolean
        },
        printBtnFunction: {
            type: Function,
            default: () => {}
        },
        abbreviation: {
            type: String,
        },
    },
    computed: {
        data() { return this.$store.getters["get" + this.context + "Details"] },
        // prevRoute() { return this.$store.getters.getPrevRoute },
        
        activePanels: { // needs to be an Array e.g. Panel 0 and 2 = [0,2]
            get() { return this.$store.getters['get' + this.context + 'ActivePanels'] },
            set(panels) { this.$store.commit('set' + this.context + 'ActivePanels', panels) }
        },
        // getPrevRoute() {
        //     // If the user reloaded the edit form, the prevRoute will be set to default '/'
        //     // So we have to build the prevRoute out of the URL, to get back to the root url of the edit form.
        //     if(this.prevRoute === '/') {
        //         // if the URL was the URL for a new entry (".../new"), we need to build the prevRoute by cutting off the "new" at the end of the URL
        //         if(this.$route.params.alvId === 'new') return this.$route.path.substring(0, this.$route.path.length - 3)
        //         // if the URL was for a existing entry (".../ALV000000001XX"), wee need to build the prevRoute by cutting off the ALVID at the end of the URL
        //         else return this.$route.path.substring(0, this.$route.path.length - 14)
        //     } else {
        //         // in any other case we can just use the prevRoute, that is set in the vuex store.
        //         // this prevRoute is set in the beforeRouteEnter router guard in every edit form file (e.g. WorkEdit)
        //         return this.prevRoute
        //     }
        // }
        isLoading: {
            get() { return this.$store.getters.getIsLoading },
            set(value) { this.$store.commit('setIsLoading', value)}
        }
    },
    methods: {
        async submit() {
            this.isLoading = true
            await this.$store.dispatch('save'+ this.context + 'Form')
            this.isLoading = false
        },
        // TODO: delete everything related to that, it is not necessary anymore!
        generateUniqueFormId(){
            let timestamp = (new Date()).getTime()
            let uniqueId = 'ALV' + timestamp
            
            switch(this.context) {
                case 'AzPersons':
                    uniqueId += 'AP'
                    break
                case 'Sheet': 
                    uniqueId += 'PS'
                    break
                case 'PublishingRelease':
                    uniqueId += 'PR'
                    break
                case 'Track':
                    uniqueId += 'LT'
                    break
                case 'PublishingContract':
                    uniqueId += 'CP'
                    break
                case 'LabelContract':
                    uniqueId += 'CL'
                    break
                case 'Companies':
                    uniqueId += 'AG'
            }            

            uniqueId += 'TMP'
            return uniqueId
        },   
        // numberOfChangedFields() {

            // if(!this.contractDataCopy[0] || this.contractDataCopy[0] === undefined) return '(0)'

            // ToDo: Maybe like this: https://gomakethings.com/getting-the-differences-between-two-objects-with-vanilla-js/ ??

        // },
    },
    created() {
        this.isLoading = true

        // Reset all selected and single checkboxes on listpage 
        if(this.$store._mutations['setIsAllSelected' + this.context]) {
            this.$store.commit('setIsAllSelected' + this.context, false)
        }
        if(this.$store._mutations['setSelected' + this.context]) {
            this.$store.commit('setSelected' + this.context, [])
        }

        // Get Edit Form Details
        let uniqueId = this.generateUniqueFormId();
        if(this.$store._mutations['set' + this.context + 'UniqueId']) {
            this.$store.commit('set' + this.context + 'UniqueId', uniqueId)
        }
        this.$store.dispatch('fetch' + this.context + 'Details', this.$route.params.alvId)

        // Check if function exists for preparing data on opening edit form
        // Dropdowns which need to be returned from BE.
        if (this.$store._actions['prepare' + this.context + 'EditFormData']) {
            this.$store.dispatch('prepare' + this.context + 'EditFormData')
        }

        this.isLoading = false
    }
}
</script>